import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { useEffect } from "react";
import Home from "./pages/Home";
import Gallery from "./pages/Gallery";
import About from "./pages/About";
import JoinUs from "./pages/Contact";
import Dashboard from "./pages/Dashboard";
import Trucks from "./pages/Trucks";
import AuthCallback from "./pages/AuthCallback";
import Team from "./pages/Team";
import CdlScheduling from "./pages/CdlScheduling";
import Inventory from "./pages/Inventory";
import Legal from "./pages/Legal";
import ProtectedRoute from "./components/ProtectedRoute";
import Header from "./components/Header";
import Footer from "./components/Footer";
import { preferencesAPI } from "./api";

function applyTheme(mode, accent) {
  const el = document.documentElement;
  el.setAttribute("data-mode",   mode   || "dark");
  el.setAttribute("data-accent", accent || "purple");
}

function App() {
  useEffect(() => {
    // Apply saved theme from localStorage immediately (no flash)
    const saved = localStorage.getItem("gty_theme");
    if (saved) {
      try {
        const { mode, accent } = JSON.parse(saved);
        applyTheme(mode, accent);
      } catch {}
    }

    // If logged in, sync from server
    const token = localStorage.getItem("gty_token");
    if (token) {
      preferencesAPI.get()
        .then(r => {
          const { theme_mode, theme_accent } = r.data;
          applyTheme(theme_mode, theme_accent);
          localStorage.setItem("gty_theme", JSON.stringify({ mode: theme_mode, accent: theme_accent }));
        })
        .catch(() => {});
    }
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/gallery" element={<Gallery />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<JoinUs />} />
          <Route path="/meetourteam" element={<Team />} />
          <Route path="/cdl" element={<CdlScheduling />} />
          <Route path="/privacy" element={<Legal type="privacy" />} />
          <Route path="/terms" element={<Legal type="terms" />} />
          <Route path="/auth/callback" element={<AuthCallback />} />
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/trucks"
            element={
              <ProtectedRoute>
                <Trucks />
              </ProtectedRoute>
            }
          />
          <Route
            path="/inventory"
            element={
              <ProtectedRoute>
                <Inventory />
              </ProtectedRoute>
            }
          />
        </Routes>
        <Footer />
      </BrowserRouter>
      <Toaster />
    </div>
  );
}

export default App;
